import { configureStore } from "@reduxjs/toolkit";

import AccountDetailsSlice from "./Reducers/AccountDetailsSlice";
import AccountPlanAccessSlice from "./Reducers/AccountPlanAccessSlice";
import AccountPlanSlice from "./Reducers/AccountPlanSlice";
import AccountPlanTemplateSlice from "./Reducers/AccountPlanTemplateSlice";
import AccountWorkspaceSlice from "./Reducers/AccountWorkspaceSlice";
import AdminSlice from "./Reducers/AdminSlice";
import AdminTipsSlice from "./Reducers/AdminTipsSlice";
import AlwaysOnChannelSlice from "./Reducers/AlwaysOnChannelSlice";
import AssessmentSlice from "./Reducers/AssessmentSlice";
import AssignmentSlice from "./Reducers/AssignmentSlice";
import AuthSlice from "./Reducers/AuthSlice";
import BriefDocumentSlice from "./Reducers/BriefDocumentSlice";
import CoverageSlice from "./Reducers/CoverageSlice";
import CustomerWorkspaceSlice from "./Reducers/CustomerWorkspaceSlice";
import { NON_SERIALIZABLE_DATA_HUB_ACTIONS } from "./Reducers/DataHubConsoleSlice";
import DataHubSlice from "./Reducers/DataHubSlice";
import EasyOnboardingSlice from "./Reducers/EasyOnboardingSlice";
import EmailActivitySlice from "./Reducers/EmailActivitySlice";
import GuidanceSlice from "./Reducers/GuidanceSlice";
import LoaderSlice from "./Reducers/LoaderSlice";
import MasterSlice from "./Reducers/MasterSlice";
import MetricsSlice from "./Reducers/MetricsSlice";
import MyPortfolioOverviewSlice from "./Reducers/MyPortfolioOverviewSlice";
import NotificationSlice from "./Reducers/NotificationSlice";
import OpsSlice from "./Reducers/OpsSlice";
import PortfolioMapSlice from "./Reducers/PortfolioMapSlice";
import RelationshipSlice from "./Reducers/RelationshipSlice";
import SignalAdminSlice from "./Reducers/SignalAdminSlice";
import SignalFeedSlice from "./Reducers/SignalFeedSlice";
import SignalHistorySlice from "./Reducers/SignalHistorySlice";
import SponsorEngagementSlice from "./Reducers/SponsorEngagementSlice";
import SponsorTipsSlice from "./Reducers/SponsorTipsSlice";
import TeamViewsSlice from "./Reducers/TeamViewsSlice";
import VendorAdminSlice from "./Reducers/VendorAdminSlice";
import VideoSlice from "./Reducers/VideoSlice";
import XFactorBriefingSlice from "./Reducers/XFactorBriefingSlice";
import XFactorKpiSlice from "./Reducers/XFactorKpiSlice";
import XFactorViewsSlice from "./Reducers/XFactorViewsSlice";

export const Store = configureStore({
  reducer: {
    loader: LoaderSlice,
    authentication: AuthSlice,
    accountDetails: AccountDetailsSlice,
    accountPlan: AccountPlanSlice,
    accountPlanTemplate: AccountPlanTemplateSlice,
    accountPlanAccess: AccountPlanAccessSlice,
    admin: AdminSlice,
    accountWorkspace: AccountWorkspaceSlice,
    alwaysOnChannel: AlwaysOnChannelSlice,
    assessment: AssessmentSlice,
    master: MasterSlice,
    briefDocument: BriefDocumentSlice,
    coverage: CoverageSlice,
    customerWorkspace: CustomerWorkspaceSlice,
    easyOnboarding: EasyOnboardingSlice,
    emailActivity: EmailActivitySlice,
    guidance: GuidanceSlice,
    relationship: RelationshipSlice,
    teamViews: TeamViewsSlice,
    sponsorEngagement: SponsorEngagementSlice,
    sponsorTips: SponsorTipsSlice,
    ops: OpsSlice,
    assignments: AssignmentSlice,
    vendorAdmin: VendorAdminSlice,
    notification: NotificationSlice,
    video: VideoSlice,
    adminTips: AdminTipsSlice,
    metrics: MetricsSlice,
    dataHub: DataHubSlice,
    xfactorBriefing: XFactorBriefingSlice,
    xfactorViews: XFactorViewsSlice,
    xfactorKpi: XFactorKpiSlice,
    myPortfolioOverview: MyPortfolioOverviewSlice,
    signalAdmin: SignalAdminSlice,
    signalFeed: SignalFeedSlice,
    signalHistory: SignalHistorySlice,
    portfolioMap: PortfolioMapSlice,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: { ignoredActions: NON_SERIALIZABLE_DATA_HUB_ACTIONS },
    }),
});

export default Store;
export type RootState = ReturnType<typeof Store.getState>;
export type AppDispatch = typeof Store.dispatch;
